import { useIntl } from 'react-intl'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import InputEmail from '../../Inputs/InputEmail/InputEmail'
import FormLayout from '../FormLayout/FormLayout'

import './FormForgottenPassword.scss'

const FormForgottenPassword = ({ handleSubmit, handleCancel, loading }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: { email: '' },
        validationSchema: Yup.object({
            email: Yup.string()
                .email(intl.formatMessage({ id: 'forms.login.emailError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
        }),
        onSubmit: (values) => handleSubmit(values),
    })

    return (
        <FormLayout onSubmit={formik.handleSubmit}>
            <InputEmail
                id={'email'}
                name={'email'}
                error={formik?.errors?.email}
                touched={formik?.touched?.email}
                disabled={loading}
                {...formik.getFieldProps('email')}
                label={intl.formatMessage({ id: 'forms.forgottenPassword.emailLabel' })}
                placeholder={intl.formatMessage({ id: 'forms.forgottenPassword.emailPlaceholder' })}
                onBlur={formik?.handleBlur}
            />
            <div className="buttons-forgotten-pass d-flex">
                <ButtonCinestar variant="primary-v1" type="submit" disabled={loading} className={'text-nowrap'}>
                    {intl.formatMessage({ id: 'forms.forgottenPassword.buttonSend' })}
                </ButtonCinestar>
                <ButtonCinestar
                    variant="secondary"
                    iconLeft="cross"
                    type="button"
                    disabled={loading}
                    onClick={handleCancel}
                >
                    {intl.formatMessage({ id: 'forms.forgottenPassword.buttonCancel' })}
                </ButtonCinestar>
            </div>
        </FormLayout>
    )
}

export default FormForgottenPassword
